module.exports = __webpack_public_path__ + "static/img/3.c028cf2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/eng/3.png
// module id = Dfcj
// module chunks = 0